import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  Paper,
  Divider,
  Grid,
  MenuItem,
  InputAdornment,
  IconButton,
  Chip,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Card,
  CardContent,
  Tab,
  Tabs,
  Switch,
  FormControlLabel,
  Avatar
} from '@mui/material';
import {
  Storefront as StorefrontIcon,
  Restaurant as RestaurantIcon,
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Description as DescriptionIcon,
  AccessTime as AccessTimeIcon,
  AttachMoney as AttachMoneyIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Save as SaveIcon,
  Edit as EditIcon,
  Map as MapIcon,
  Category as CategoryIcon,
  Fastfood as FastfoodIcon,
  Schedule as ScheduleIcon,
  LocalOffer as LocalOfferIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import GoogleMapModal from '../components/GoogleMapModal';
import ImageUpload from '../components/ImageUpload';
import CurrencyTrans from '../components/CarrancyTrans';

const OwnerMenuEdit = ({ keywordsData,language }) => {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [openMap, setOpenMap] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const [formData, setFormData] = useState({
    id: null,
    name: '',
    name_en: '',
    description: '',
    description_en: '',
    phone: '',
    email: '',
    address: '',
    address_en: '',
    city: '',
    area: '',
    latitude: null,
    longitude: null,
    cuisine_type: '',
    currency: 'MYR',
    delivery_fee: '0',
    min_order_amount: '0',
    delivery_time_min: '30',
    preparation_time_min: '15',
    logo: '',
    cover_image: '',
    is_active: true,
    featured: false,
    opening_hours: {},
    delivery_radius_km: 10
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const cuisineTypes = ['Restaurant', 'Pharmacy', 'Super market', 'Car', 'Home', 'Cafe', 'Bakery', 'Fast Food'];
  const currencies = ['EGP', 'USD', 'EUR', 'MYR', 'SAR'];
  const deliveryRadiusOptions = [5, 10, 15, 20, 25, 30, 50];

  useEffect(() => {
    fetchMyRestaurant();
  }, []);

  const fetchMyRestaurant = async () => {
    setFetching(true);
    try {
      const response = await api.get('/restaurants/my-restaurant');
      const restaurantData = response.data.restaurant;
      
      setRestaurant(restaurantData);
      setFormData({
        id: restaurantData.id,
        name: restaurantData.name || '',
        name_en: restaurantData.name_en || '',
        description: restaurantData.description || '',
        description_en: restaurantData.description_en || '',
        phone: restaurantData.phone || '',
        email: restaurantData.email || '',
        address: restaurantData.address || '',
        address_en: restaurantData.address_en || '',
        city: restaurantData.city || '',
        area: restaurantData.area || '',
        latitude: restaurantData.latitude || null,
        longitude: restaurantData.longitude || null,
        cuisine_type: restaurantData.cuisine_type || '',
        currency: restaurantData.currency || 'MYR',
        delivery_fee: restaurantData.delivery_fee?.toString() || '0',
        min_order_amount: restaurantData.min_order_amount?.toString() || '0',
        delivery_time_min: restaurantData.delivery_time_min?.toString() || '30',
        preparation_time_min: restaurantData.preparation_time_min?.toString() || '15',
        logo: restaurantData.logo || '',
        cover_image: restaurantData.cover_image || '',
        is_active: restaurantData.is_active || false,
        featured: restaurantData.featured || false,
        opening_hours: restaurantData.opening_hours || {},
        delivery_radius_km: restaurantData.delivery_radius_km || 10
      });
      
      if (restaurantData.latitude && restaurantData.longitude) {
        setSelectedLocation({
          lat: restaurantData.latitude,
          lng: restaurantData.longitude,
          address: restaurantData.address
        });
      }
    } catch (error) {
      console.error('Error fetching store:', error);
      if (error.response?.status === 404) {
        setMessage({
          type: 'warning',
          text: language === 'ar' 
            ? 'لم تقم بإنشاء متجر بعد. يرجى تقديم طلب فتح متجر أولاً.'
            : 'You haven\'t created a store yet. Please submit a store opening request first.'
        });
      } else {
        setMessage({
          type: 'error',
          text: error.response?.data?.message || (language === 'ar' ? 'فشل في تحميل بيانات المتجر' : 'Failed to load store data')
        });
      }
    } finally {
      setFetching(false);
    }
  };

  const handleChange = (field) => (event) => {
    setFormData(prev => ({ ...prev, [field]: event.target.value }));
    if (touched[field]) {
      setErrors(prev => ({ ...prev, [field]: validateField(field, event.target.value) }));
    }
  };

  const handleSwitchChange = (field) => (event) => {
    setFormData(prev => ({ ...prev, [field]: event.target.checked }));
  };

      // Handle auto-detect location
    const handleAutoDetect = () => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setSelectedLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setOpenMap(true);
        },
        (error) => {
          alert(language === 'ar' ? keywordsData.enable_gps_ar : keywordsData.enable_gps_en);
        }
      );
    };

    // Google Maps API
  const loadGoogleMapsAPI = (callback) => {
    if (window.google && window.google.maps) {
      callback();
      return;
    }
  
    if (!document.getElementById("google-maps-script")) {
      const script = document.createElement("script");
      const api = 'AIzaSyBl9P55wDymA5tQzFgWFaZWgMyQMdOSWXA';
      script.id = "google-maps-script";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${api}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log("Google Maps API Loaded");
        callback();
      };
      script.onerror = () => {
        console.error("Failed to load Google Maps API.");
      };
      document.body.appendChild(script);
    } else {
      setTimeout(() => {
        if (window.google && window.google.maps) {
          callback();
        }
      }, 1000);
    }
  };


  const handleLocationSelect = (location) => {
    if (!window.google || !window.google.maps) {
      loadGoogleMapsAPI(() => handleLocationSelect(location));
      return;
    }
    setSelectedLocation(location);
    setFormData(prev => ({
      ...prev,
      latitude: location.lat,
      longitude: location.lng,
      address: location.address || prev.address
    }));
  };

  const handleImageChange = (field) => (imageUrl) => {
    setFormData(prev => ({ ...prev, [field]: imageUrl }));
    if (touched[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateField = (field, value) => {
    switch (field) {
      case 'name':
        if (!value) return language === 'ar' ? 'اسم المتجر مطلوب' : 'Store name is required';
        if (value.length < 3) return language === 'ar' ? 'اسم المتجر يجب أن يكون 3 أحرف على الأقل' : 'Store name must be at least 3 characters';
        return '';
      case 'phone':
        if (!value) return language === 'ar' ? 'رقم الهاتف مطلوب' : 'Phone number is required';
        const cleanPhone = value.replace(/[\s\-\(\)\.]/g, '');
        const phoneRegex = /^(\+?[0-9]{1,3})?[0-9]{7,12}$/;
        if (!phoneRegex.test(cleanPhone)) {
          return language === 'ar' 
            ? 'الرجاء إدخال رقم هاتف صالح (مثال: 0123456789 أو +20123456789)' 
            : 'Please enter a valid phone number (e.g., 0123456789 or +20123456789)';
        }
        const digitCount = cleanPhone.replace(/\+/g, '').length;
        if (digitCount < 7 || digitCount > 15) {
          return language === 'ar' 
            ? 'رقم الهاتف يجب أن يحتوي على 7-15 رقم' 
            : 'Phone number must contain 7-15 digits';
        }
        return '';
      case 'email':
        if (!value) return language === 'ar' ? 'البريد الإلكتروني مطلوب' : 'Email is required';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) return language === 'ar' ? 'يرجى إدخال عنوان بريد إلكتروني صالح' : 'Please enter a valid email address';
        return '';
      case 'address':
        if (!value) return language === 'ar' ? 'العنوان مطلوب' : 'Address is required';
        return '';
      case 'city':
        if (!value) return language === 'ar' ? 'المدينة مطلوبة' : 'City is required';
        return '';
      case 'delivery_fee':
        if (value && (value < 0 || value > 100)) {
          return language === 'ar' ? 'رسوم التوصيل يجب أن تكون بين 0 و 100' : 'Delivery fee must be between 0 and 100';
        }
        return '';
      case 'min_order_amount':
        if (value && value < 0) {
          return language === 'ar' ? 'الحد الأدنى للطلب لا يمكن أن يكون سالباً' : 'Minimum order amount cannot be negative';
        }
        return '';
      default:
        return '';
    }
  };

  const handleBlur = (field) => () => {
    setTouched(prev => ({ ...prev, [field]: true }));
    setErrors(prev => ({ ...prev, [field]: validateField(field, formData[field]) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newTouched = {};
    const newErrors = {};
    const requiredFields = ['name', 'phone', 'email', 'address', 'city'];
    
    requiredFields.forEach(field => {
      newTouched[field] = true;
      newErrors[field] = validateField(field, formData[field]);
    });
    
    setTouched(newTouched);
    setErrors(newErrors);
    
    if (Object.values(newErrors).some(error => error)) {
      setMessage({ 
        type: 'error', 
        text: language === 'ar' ? 'يرجى تصحيح الأخطاء الموجودة في النموذج' : 'Please correct the errors in the form' 
      });
      return;
    }
    
    setLoading(true);
    
    try {
      const submitData = {
        name: formData.name,
        name_en: formData.name_en,
        description: formData.description,
        description_en: formData.description_en,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        address_en: formData.address_en,
        city: formData.city,
        area: formData.area,
        latitude: formData.latitude,
        longitude: formData.longitude,
        cuisine_type: formData.cuisine_type,
        currency: formData.currency,
        delivery_fee: parseFloat(formData.delivery_fee),
        min_order_amount: parseFloat(formData.min_order_amount),
        delivery_time_min: parseInt(formData.delivery_time_min),
        preparation_time_min: parseInt(formData.preparation_time_min),
        logo: formData.logo,
        cover_image: formData.cover_image,
        is_active: formData.is_active,
        featured: formData.featured,
        delivery_radius_km: formData.delivery_radius_km
      };
      
      const response = await api.put(`/restaurants/update/${formData.id}`, submitData);
      
      setMessage({ 
        type: 'success', 
        text: language === 'ar' 
          ? 'تم تحديث بيانات المتجر بنجاح!' 
          : 'Store data updated successfully!' 
      });
      
      // Refresh data
      fetchMyRestaurant();
      
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || (language === 'ar' ? 'فشل في تحديث البيانات' : 'Failed to update data') 
      });
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <Container maxWidth="md" sx={{ py: 4, backgroundColor: '#000000', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress sx={{ color: '#FFD700' }} />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ 
      py: 4, 
      mb: 10,
      backgroundColor: '#000000',
      minHeight: '100vh',
      color: '#FFFFFF'
    }}>
      {/* Header with Back Button */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <IconButton 
          onClick={() => navigate('/admin')}
          sx={{ 
            color: '#FFD700',
            '&:hover': {
              backgroundColor: 'rgba(255, 215, 0, 0.1)'
            }
          }}
        >
          {language === 'ar' ? <ArrowForwardIcon /> : <ArrowBackIcon /> }
        </IconButton>
        <StorefrontIcon sx={{ fontSize: 48, color: '#FFD700' }} />
        <Typography variant="h3" sx={{ 
          color: '#FFD700',
          fontWeight: 900,
          letterSpacing: '2px'
        }}>
          {language === 'ar' ? 'تعديل بيانات المتجر' : 'Edit Store'}
        </Typography>
      </Box>

      {/* Restaurant Status Card */}
      <Paper sx={{ 
        p: 3, 
        mb: 4,
        backgroundColor: formData.is_active ? 'rgba(76, 175, 80, 0.1)' : 'rgba(255, 61, 0, 0.1)',
        border: `1px solid ${formData.is_active ? '#4CAF50' : '#FF3D00'}`,
        borderRadius: '16px'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {formData.is_active ? (
              <Chip icon={<StorefrontIcon />} label={language === 'ar' ? 'المتجر نشط' : 'Store Active'} color="success" />
            ) : (
              <Chip icon={<StorefrontIcon />} label={language === 'ar' ? 'المتجر غير نشط' : 'Store Inactive'} color="error" />
            )}
            {formData.featured && (
              <Chip icon={<LocalOfferIcon />} label={language === 'ar' ? 'مميز' : 'Featured'} color="warning" />
            )}
          </Box>
          <Typography variant="body2" sx={{ color: '#B3B3B3' }}>
            {language === 'ar' 
              ? 'يمكنك تعديل بيانات متجرك من هنا. التغييرات ستظهر للمستخدمين فوراً.'
              : 'You can edit your Store data here. Changes will appear to users immediately.'}
          </Typography>
        </Box>
      </Paper>

      {message.text && (
        <Alert 
          severity={message.type} 
          sx={{ 
            mb: 3,
            backgroundColor: message.type === 'success' ? 'rgba(255, 215, 0, 0.1)' : 'rgba(255, 61, 0, 0.1)',
            color: message.type === 'success' ? '#FFD700' : '#FF3D00',
            border: `1px solid ${message.type === 'success' ? '#FFD700' : '#FF3D00'}`,
            borderRadius: '12px'
          }}
        >
          {message.text}
        </Alert>
      )}

      {/* Tabs */}
      <Tabs 
        value={activeTab} 
        onChange={(e, v) => setActiveTab(v)} 
        sx={{ 
          mb: 3,
          '& .MuiTab-root': { color: '#B3B3B3' },
          '& .Mui-selected': { color: '#FFD700' },
          '& .MuiTabs-indicator': { backgroundColor: '#FFD700' }
        }}
      >
        <Tab icon={<RestaurantIcon />} label={language === 'ar' ? 'المعلومات الأساسية' : 'Basic Info'} />
        <Tab icon={<LocationOnIcon />} label={language === 'ar' ? 'الموقع' : 'Location'} />
        <Tab icon={<AccessTimeIcon />} label={language === 'ar' ? 'الإعدادات' : 'Settings'} />
      </Tabs>

      {/* Main Form Card */}
      <Paper sx={{ 
        p: 4,
        backgroundColor: '#0D0D0D',
        border: '1px solid #2D2D2D',
        borderRadius: '24px',
        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.1)'
      }}>
        <Box component="form" onSubmit={handleSubmit}>
          {/* Basic Info Tab */}
          {activeTab === 0 && (
            <>
              {/* Images Section */}
              <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <StorefrontIcon sx={{ color: '#FFD700' }} /> 
                {language === 'ar' ? 'صور المتجر' : 'Store Images'}
              </Typography>
              <Divider sx={{ backgroundColor: '#2D2D2D', mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ color: '#B3B3B3', fontSize: '0.9rem', mb: 1 }}>
                    {language === 'ar' ? 'شعار المتجر' : 'Store Logo'}
                  </Typography>
                  <ImageUpload
                    key="logo-upload"
                    value={formData.logo}
                    onChange={handleImageChange('logo')}
                    productName={formData.name}
                    language={language}
                    noTitle={true}
                    setIsUploading={setIsUploading}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ color: '#B3B3B3', fontSize: '0.9rem', mb: 1 }}>
                    {language === 'ar' ? 'صورة الغلاف' : 'Cover Image'}
                  </Typography>
                  <ImageUpload
                    key="cover-upload"
                    value={formData.cover_image}
                    onChange={handleImageChange('cover_image')}
                    productName={formData.name}
                    language={language}
                    noTitle={true}
                    setIsUploading={setIsUploading}
                  />
                </Grid>
              </Grid>

              {/* Restaurant Info */}
              <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2, mt: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                <RestaurantIcon sx={{ color: '#FFD700' }} /> 
                {language === 'ar' ? 'معلومات المتجر' : 'Store Information'}
              </Typography>
              <Divider sx={{ backgroundColor: '#2D2D2D', mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'اسم المتجر (عربي)' : 'Store Name (Arabic)'}
                    value={formData.name}
                    onChange={handleChange('name')}
                    onBlur={handleBlur('name')}
                    error={touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    required
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'اسم المتجر (إنجليزي)' : 'Store Name (English)'}
                    value={formData.name_en}
                    onChange={handleChange('name_en')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'رقم الهاتف' : 'Phone Number'}
                    value={formData.phone}
                    onChange={handleChange('phone')}
                    onBlur={handleBlur('phone')}
                    error={touched.phone && !!errors.phone}
                    helperText={touched.phone && errors.phone}
                    required
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'البريد الإلكتروني' : 'Email'}
                    type="email"
                    value={formData.email}
                    onChange={handleChange('email')}
                    onBlur={handleBlur('email')}
                    error={touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                    required
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label={language === 'ar' ? 'الوصف (عربي)' : 'Description (Arabic)'}
                    value={formData.description}
                    onChange={handleChange('description')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label={language === 'ar' ? 'الوصف (إنجليزي)' : 'Description (English)'}
                    value={formData.description_en}
                    onChange={handleChange('description_en')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ color: '#B3B3B3' }}>{language === 'ar' ? 'نوع المتجر' : 'Store Type'}</InputLabel>
                    <Select
                      value={formData.cuisine_type}
                      onChange={handleChange('cuisine_type')}
                      label={language === 'ar' ? 'نوع المتجر' : 'Store Type'}
                      sx={{ backgroundColor: '#1A1A1A', color: '#FFFFFF', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2D2D2D' } }}
                    >
                      {cuisineTypes.map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ color: '#B3B3B3' }}>{language === 'ar' ? 'العملة' : 'Currency'}</InputLabel>
                    <Select
                      value={formData.currency}
                      onChange={handleChange('currency')}
                      label={language === 'ar' ? 'العملة' : 'Currency'}
                      sx={{ backgroundColor: '#1A1A1A', color: '#FFFFFF', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2D2D2D' } }}
                    >
                      {currencies.map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}

          {/* Location Tab */}
          {activeTab === 1 && (
            <>
              <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ color: '#FFD700' }} /> 
                {language === 'ar' ? 'معلومات الموقع' : 'Location Information'}
              </Typography>
              <Divider sx={{ backgroundColor: '#2D2D2D', mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'المدينة' : 'City'}
                    value={formData.city}
                    onChange={handleChange('city')}
                    onBlur={handleBlur('city')}
                    error={touched.city && !!errors.city}
                    helperText={touched.city && errors.city}
                    required
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'المنطقة' : 'Area'}
                    value={formData.area}
                    onChange={handleChange('area')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label={language === 'ar' ? 'العنوان التفصيلي' : 'Detailed Address'}
                    value={formData.address}
                    onChange={handleChange('address')}
                    onBlur={handleBlur('address')}
                    error={touched.address && !!errors.address}
                    helperText={touched.address && errors.address}
                    required
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label={language === 'ar' ? 'العنوان (إنجليزي)' : 'Address (English)'}
                    value={formData.address_en}
                    onChange={handleChange('address_en')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleAutoDetect}
                    startIcon={<MapIcon />}
                    sx={{
                      py: 1.5,
                      borderColor: formData.latitude ? '#4CAF50' : '#FFD700',
                      color: formData.latitude ? '#4CAF50' : '#FFD700',
                      '&:hover': { borderColor: '#FFE55C', backgroundColor: 'rgba(255, 215, 0, 0.1)' }
                    }}
                  >
                    {formData.latitude 
                      ? `${language === 'ar' ? 'تم اختيار الموقع' : 'Location Selected'} (${formData.latitude}, ${formData.longitude})`
                      : language === 'ar' ? 'اختر موقع المتجر على الخريطة' : 'Select store location on map'}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}

          {/* Settings Tab */}
          {activeTab === 2 && (
            <>
              <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <AccessTimeIcon sx={{ color: '#FFD700' }} /> 
                {language === 'ar' ? 'الإعدادات' : 'Settings'}
              </Typography>
              <Divider sx={{ backgroundColor: '#2D2D2D', mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'رسوم التوصيل' : 'Delivery Fee'}
                    type="number"
                    value={formData.delivery_fee}
                    onChange={handleChange('delivery_fee')}
                    onBlur={handleBlur('delivery_fee')}
                    error={touched.delivery_fee && !!errors.delivery_fee}
                    helperText={touched.delivery_fee && errors.delivery_fee}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'الحد الأدنى للطلب' : 'Minimum Order Amount'}
                    type="number"
                    value={formData.min_order_amount}
                    onChange={handleChange('min_order_amount')}
                    onBlur={handleBlur('min_order_amount')}
                    error={touched.min_order_amount && !!errors.min_order_amount}
                    helperText={touched.min_order_amount && errors.min_order_amount}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'وقت التوصيل المتوقع (دقائق)' : 'Estimated Delivery Time (minutes)'}
                    type="number"
                    value={formData.delivery_time_min}
                    onChange={handleChange('delivery_time_min')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={language === 'ar' ? 'وقت التحضير (دقائق)' : 'Preparation Time (minutes)'}
                    type="number"
                    value={formData.preparation_time_min}
                    onChange={handleChange('preparation_time_min')}
                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#1A1A1A', color: '#FFFFFF', '& fieldset': { borderColor: '#2D2D2D' }, '&:hover fieldset': { borderColor: '#FFD700' } } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ color: '#B3B3B3' }}>{language === 'ar' ? 'نطاق التوصيل (كم)' : 'Delivery Radius (km)'}</InputLabel>
                    <Select
                      value={formData.delivery_radius_km}
                      onChange={handleChange('delivery_radius_km')}
                      label={language === 'ar' ? 'نطاق التوصيل (كم)' : 'Delivery Radius (km)'}
                      sx={{ backgroundColor: '#1A1A1A', color: '#FFFFFF', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2D2D2D' } }}
                    >
                      {deliveryRadiusOptions.map(radius => <MenuItem key={radius} value={radius}>{radius} km</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, backgroundColor: '#1A1A1A', borderRadius: '8px' }}>
                    <Typography sx={{ color: '#B3B3B3' }}>{language === 'ar' ? 'نشط' : 'Active'}</Typography>
                    <Switch checked={formData.is_active} onChange={handleSwitchChange('is_active')} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#FFD700' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FFD700' } }} />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, backgroundColor: '#1A1A1A', borderRadius: '8px' }}>
                    <Typography sx={{ color: '#B3B3B3' }}>{language === 'ar' ? 'مميز' : 'Featured'}</Typography>
                    <Switch checked={formData.featured} onChange={handleSwitchChange('featured')} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#FFD700' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FFD700' } }} />
                  </Box>
                </Grid>
              </Grid>
            </>
          )}

          {/* Submit Button */}
          <Button 
            type="submit" 
            variant="contained" 
            size="large"
            fullWidth
            disabled={loading || isUploading}
            startIcon={loading ? <CircularProgress size={24} /> : <SaveIcon />}
            sx={{ 
              mt: 4,
              py: 1.8,
              backgroundColor: '#FFD700',
              color: '#000000',
              fontWeight: 800,
              fontSize: '1.1rem',
              borderRadius: '12px',
              '&:hover': { backgroundColor: '#FFE55C', transform: 'translateY(-2px)' },
              '&.Mui-disabled': { backgroundColor: '#666', color: '#999' },
              transition: 'all 0.2s ease'
            }}
          >
            {loading 
              ? (language === 'ar' ? 'جاري الحفظ...' : 'Saving...') 
              : (language === 'ar' ? 'حفظ التغييرات' : 'Save Changes')}
          </Button>
        </Box>
      </Paper>

      {/* Google Maps Modal */}
      <GoogleMapModal
        open={openMap}
        handleClose={() => setOpenMap(false)}
        onLocationSelect={handleLocationSelect}
        initialCenter={selectedLocation}
        language={language}
        keywordsData={{}}
      />
    </Container>
  );
};

export default OwnerMenuEdit;